import React from 'react';
import ProtectionPlans from './ProtectionPlans';
import HowItWorks from './HowItWorks';

import coverageImage from '../assets/icons/coverageImage1.jpg';
import hospitalIcon from '../assets/icons/hospital.svg';
import cashIcon from '../assets/icons/cash.svg';
import icuIcon from '../assets/icons/icu.svg';
import doctorIcon from '../assets/icons/icons8-call-100.png';
import '../style.css';

const AboutProduct = (props) => {

    const handleRedirection = () => {
        props?.redirectToStep();
    };

    return (
        <div className="card-container">
            <div className="card-image">
                <img src={coverageImage} alt="Coverage" />
                {/* <div className="image-text">
                    <h2>Choose ₹500 or ₹1,000 daily coverage</h2>
                </div> */}
            </div>
            <div className="card-content">
                <h2>Assure fixed daily cash on hospital admission</h2>
                <div className="features">
                    <div className="feature">
                        <img src={hospitalIcon} alt="Hospital" />
                        <p>More than 8000+ hospitals across India</p>
                    </div>
                    <div className="feature">
                        <img src={cashIcon} alt="Cash" />
                        <p>Fixed cash per day, no questions asked</p>
                    </div>
                    <div className="feature">
                        <img src={icuIcon} alt="ICU" />
                        <p>Twice the amount in case of ICU admission</p>
                    </div>
                    <div className="feature">
                        <img src={doctorIcon} alt="Doctor" />
                        <p>Unlimited Doctor Tele consultations</p>
                    </div>
                </div>
                <button className="select-plan-button" onClick={() => handleRedirection()}>Proceed To Select Plan</button>
                <ProtectionPlans/>
                <HowItWorks/>
                <button className="select-plan-button" style = {{marginTop : 10}} onClick={() => handleRedirection()}>Proceed To Select Plan</button>
            </div>
        </div>
    );
}

export default AboutProduct;